import { call, put } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import { getInstructorReviewSummaryActions } from "../slices";

function* getInstructorReviewSummaryWorker() {
  try {
    yield put(getInstructorReviewSummaryActions.pending());
    const responseSummary = yield call(reviewApi.getReviewSummaryInstructor);
    const responseAvgRating = yield call(reviewApi.getAverageRatingInstructor);
    const responseTotalReviews = yield call(reviewApi.getTotalReviewInstructor);

    const payloadSuccess = {
      ratingList: responseSummary.data,
      avgRating: responseAvgRating.data,
      totalReviews: responseTotalReviews.data,
    };

    yield put(getInstructorReviewSummaryActions.success(payloadSuccess));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getInstructorReviewSummaryActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getInstructorReviewSummaryWorker };
